<template>
  <div id="app">
    <transition name="applide" v-if="getDirectControl">
      <!-- <keep-alive> -->
        <router-view class="router-view"/>
      <!-- </keep-alive> -->
    </transition>
    <transition name="appSlideRight" v-if="!getDirectControl">
      <!-- <keep-alive> -->
        <router-view class="router-view"/>
      <!-- </keep-alive> -->
    </transition>
    
  </div>
</template>

<script>
import VHeader from '@/components/VHeader'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters(['getDirectControl'])
  },
  mounted() {
  },
  components: {
    VHeader
  }
}
</script>

<style lang='scss'>
#app {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: relative;
  .applide-enter-active {
    transition: all 0.1s ease;
  }
  .applide-leave-active {
    transition: all 0.5s ease-in-out;
  }
  .applide-enter {
    opacity: 0.9;
    transform: translateX(50%);
  }
  .applide-leave-active {
    opacity: 0;
    transform:translateX(-100%);
  }

  .appSlideRight-enter-active {
    transition: all 0.1s ease;
  }
  .appSlideRight-leave-active {
    transition: all 0.5s ease;
  }
  .appSlideRight-enter {
    opacity: 0.5;
    transform: translateX(-50%);
  }
  .appSlideRight-leave-active {
    opacity: 0;
    transform:translateX(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue